import { request } from '@/utils/request.js'
export function loginAdmin(data) {
    return request({
      url: '/admin/login/login',
      method: 'post',
      data
    })
  }
  // 客户跟进弹框提示
  export function getRemind(data) {
    return request({
      url: '/admin/remind/getRemind',
      method: 'post',
      data
    })
  }





